import { PlantItemStateModel } from '../item/plant-item.state';
import { PartnerExtIdsModel } from '../../partner/models';
import { PlantExtIdsModel } from './plant-external-ids.model';
import { mustNotBeBlankValidator } from '../../../../../common/utils';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

export class PlantDetailsModel {
  id?;
  shortName = '';
  fullName = '';
  sapPlantId = '';
  sapInboundSystem: string[];
  materialTrackingEnabled = false;
  houseNumber = '';
  street = '';
  cityName = '';
  postCode = '';
  country = '';
  plantLocation = '';
  extIds: PartnerExtIdsModel[];
  gates: string[];
  gb = '';

  constructor(params?: PlantDetailsModel | PlantItemStateModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PlantDetailsForm {
  id?;
  constructor(
    detailsModel: PlantDetailsModel,
    hasUpdatePermission: boolean = true,
    public shortName: FormControl<string> = new FormControl<string>(
      { value: detailsModel.shortName, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public fullName: FormControl<string> = new FormControl<string>(
      { value: detailsModel.fullName, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public sapPlantId: FormControl<string> = new FormControl<string>(
      { value: detailsModel.sapPlantId, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public sapInboundSystem: FormControl<string[]> = new FormControl<string[]>(
      { value: detailsModel.sapInboundSystem, disabled: !hasUpdatePermission },
      [Validators.required],
    ),
    public gates: FormControl<string[]> = new FormControl<string[]>(
      { value: detailsModel.gates, disabled: !hasUpdatePermission },
      [],
    ),
    public materialTrackingEnabled: FormControl<boolean> = new FormControl<boolean>(
      { value: detailsModel.materialTrackingEnabled, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public houseNumber: FormControl<string> = new FormControl<string>(
      { value: detailsModel.houseNumber, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public street: FormControl<string> = new FormControl<string>(
      { value: detailsModel.street, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public cityName: FormControl<string> = new FormControl<string>(
      { value: detailsModel.cityName, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public postCode: FormControl<string> = new FormControl<string>(
      { value: detailsModel.postCode, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public country: FormControl<string> = new FormControl<string>(
      { value: detailsModel.country, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public plantLocation: FormControl<string> = new FormControl<string>(
      { value: detailsModel.plantLocation, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public gb: FormControl<string> = new FormControl<string>(
      { value: detailsModel.gb, disabled: !hasUpdatePermission },
      [],
    ),
  ) {
    if (detailsModel.id) {
      this.id = [detailsModel.id, []];
    }
  }
}

export class PlantForm {
  constructor(public details: FormGroup<PlantDetailsForm>, public extIds: FormArray<FormControl<PlantExtIdsModel>>) {}
}
